import Vue from "vue";

export default {
	state: {
		workflows: [],
		workflowDetails: {},
		workflowType: "",
		workflowTypes: [],
		requestWorkflows: [],
		selectedFlowType: "",
		stepFields: []
	},

	mutations: {
		setWorkflowOnState(state, workflows) {
			state.workflows = workflows;
		},
		setWorkflowDetailsOnState(state, workflowDetails) {
			state.workflowDetails = mapWorkflow(workflowDetails);
		},
		setWorkflowTypeOnState(state, workflowType) {
			state.workflowType = workflowType;
		},
		setWorkflowTypesOnState(state, workflowTypes) {
			state.workflowTypes = workflowTypes;
		},
		addWorkflowOnState(state, workflow) {
			state.workflows.push(workflow);
		},
		setWorkflowsRequestOnState(state, requestWorkflows) {
			state.requestWorkflows = requestWorkflows;
		},
		setFlowTypeOnState(state, selectedFlowType) {
			state.selectedFlowType = selectedFlowType;
		},
		setStepFieldsOnState(state, stepFields) {
			state.stepFields = stepFields;
		}
	},

	actions: {
		newWorkflow({ commit }, workflow) {
			this.state.loading = true;
			workflow["tipoWorkflow"] = { id: workflow.id.toString() };
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Workflow", workflow)
					.then((response) => {
						this.state.loading = false;
						if (response.data.isError) {
							reject(response.data.data);
							return;
						}

						resolve(response.data.data);
						commit("addWorkflowOnState", response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		editWorkflow() {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				mapWorkflowToBack(this.state.workflowDetails).then((mappedWorkflow) => {
					Vue.prototype.$http
						.put("Workflow/" + this.state.workflowDetails.id, mappedWorkflow)
						.then((response) => {
							this.state.loading = false;

							if (response.error) {
								Vue.prototype.$functions.displayError(this._vm, response.error);
								return;
							}

							if (response.data.isError) {
								reject(response.data.data);
							}

							resolve(response);
						})
						.catch((error) => {
							this.state.loading = false;
							reject(error.message);
						});
				});
			});
		},
		async getWorkflows({ commit }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("Workflow/all").then((response) => {
					this.state.loading = false;
					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}

					let workflows = response.data.data;
					workflows.forEach((workflow) => {
						workflow["status"] = "Ativo";
					});
					resolve(response.data.data);
					commit("setWorkflowOnState", workflows);
				});
			});
		},
		getWorkflowDetails({ commit }, queryParams) {
			if (!queryParams) {
				commit("setWorkflowDetailsOnState", defaultWorkflow);
				return;
			}
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("Workflow/", queryParams).then((response) => {
					this.state.loading = false;

					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					resolve(response.data.data);
					commit("setWorkflowDetailsOnState", response.data.data);
				});
			});
		},
		getWorkflowsRequest({ commit }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("workflow/request").then((response) => {
					this.state.loading = false;
					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					commit("setWorkflowsRequestOnState", response.data.data);
					resolve(response.data.data);
				});
			});
		},
		activeWorkflow(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("Workflow/" + data + "/active")
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		inactiveWorkflow(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("Workflow/" + data.id + "/inactive/")
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		async nextStepWorkflow(_, step) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Workflow/invite/step", step)
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getWorkflowHistory(_, idInvite) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http.get(`workflow/invite/${idInvite}/history`).then((response) => {
					this.state.loading = false;
					if (response.error) {
						reject(response.error);
						return;
					}
					resolve(response.data.data);
				});
			});
		},
		getWorkflowHistoryDetails(_, idInvite) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`workflow/invite/${idInvite}/history/details`)
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							reject(response.error);
							return;
						}
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getWorkflowHistoryDetailsByStep(_, { idInvite, idStep, idClient, idHistory }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`workflow/invite/${idInvite}/history/details/${idStep}/${idClient}/${idHistory}`)
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							reject(response.error);
							return;
						}
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getWorkflowType({ commit }, id) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("Workflow/workflow/type/" + id).then((response) => {
					this.state.loading = false;

					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					resolve(response.data.data);
					commit("setWorkflowTypeOnState", response.data.data);
				});
			});
		},
		getAllWorkflowType({ commit }, filters) {
			filters = {
				activeStatus: true,
				...filters
			};
			return new Promise((resolve) => {
				Vue.prototype.$http.post("Workflow/type", filters).then((response) => {
					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}

					let workflowTypes = response.data.data;
					commit("setWorkflowTypesOnState", workflowTypes);
					resolve(workflowTypes);
				});
			});
		},
		newWorkflowType(_, workflowType) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Workflow/type/new", workflowType)
					.then((response) => {
						this.state.loading = false;

						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}

						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		editWorkflowType(_, workflowType) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("Workflow/type", workflowType)
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getStepsByClient({}, idClient) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`Workflow/stepsByClient/${idClient}`)
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						const steps = response.data.data.resultSteps;
						const stepList = Object.entries(steps).map(([key, value]) => ({
							steps: value,
							name: key.trim()
						}));
						resolve(stepList);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getStepFields({ commit }, idStep) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("workflow/stepField/" + idStep).then((response) => {
					this.state.loading = false;

					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					resolve(response.data.data);
					commit("setStepFieldsOnState", response.data.data.stepFields);
				});
			});
		}
	},

	getters: {
		workflows(state) {
			return state.workflows;
		},
		requestWorkflows(state) {
			return state.requestWorkflows;
		},
		workflowDetails(state) {
			return state.workflowDetails;
		},
		workflowTypes(state) {
			return state.workflowTypes;
		},
		workflowFields(state) {
			return state.fields;
		},
		activatedWorkflows(state) {
			const workflowsCopy = [...state.workflows];
			workflowsCopy.unshift({
				id: 0,
				nome: "-",
				ativo: true,
				haveInviteInProccess: false,
				status: "Ativo"
			});
			return workflowsCopy.filter((workflow) => workflow.ativo);
		},
		stepFields({ stepFields }) {
			return stepFields;
		}
	}
};

function mapWorkflow(workflow) {
	const { workflowApplication, clientModules, workflowFamiliesFilter } = workflow;
	let mappedWorkflow = {
		isActive: workflow.isActive ? Vue.prototype.$IsActive.ACTIVE : Vue.prototype.$IsActive.INACTIVE,
		steps: workflow.etapas.map(mapStep),
		id: workflow.id,
		name: workflow.nome,
		isCustomer: workflowApplication.isCustomer,
		isSupplier: workflowApplication.isSupplier,
		isManufactor: workflowApplication.isManufactor,
		clientModules: clientModules,
		workflowFamiliesFilter: workflowFamiliesFilter,
		supplierStatus: workflow.supplierStatus
	};
	return mappedWorkflow;
}

function mapStep(step) {
	let mappedStep = {
		actor: mapActor(step.actor),
		maximumDurationInHours: step.duracaoMaximaEmHoras,
		idStep: step.idStep,
		initialStep: step.initialStep,
		name: step.nome,
		actions: step.saidas.map(mapAction),
		sendEmail: step.sendEmail,
		sendInvite: step.sendInvite,
		retentionStepsId: step.retentionStepsId,
		retentionStep: step.isRetentionStep,
		agrupador: step.agrupador,
		haveActiveInvite: step.haveActiveInvite,
		registeredIdStep: step.registeredIdStep,
		isNewStep: step.isNewStep,
		updatedStepFields: false,
		stepFields: step.stepFields,
		environmentUniqueKey: step.environmentUniqueKey
	};
	return mappedStep;
}

function mapActor(actor) {
	if (!actor) return null;
	let mappedActor = {
		id: actor.id,
		name: actor.nome
	};
	return mappedActor;
}

function mapAction(action) {
	let mappedAction = {
		idStepAction: action.idStepAction,
		name: action.nomeAcao,
		standartAction: action.standartAction,
		sendEmail: action.sendEmail,
		type: action.tipo,
		buttonColor: action.buttonColor,
		stepActionNotifications: action.stepActionNotifications,
		destinations: action.destinations
	};
	return mappedAction;
}

function mapWorkflowToBack(workflow) {
	return new Promise((resolve) => {
		let mappedWorkflow = {
			isActive: workflow.isActive == Vue.prototype.$IsActive.ACTIVE ? true : false,
			etapas: workflow.steps.map(mapStepToBack),
			id: workflow.id,
			nome: workflow.name,
			isCustomer: workflow.isCustomer,
			isSupplier: workflow.isSupplier,
			isManufactor: workflow.isManufactor,
			workflowFamiliesFilter: workflow.workflowFamiliesFilter,
			idSupplierStatus: workflow.supplierStatus
		};
		resolve(mappedWorkflow);
	});
}

function mapStepToBack(step) {
	let mappedStep = {
		actor: mapActorToBack(step.actor),
		duracaoMaximaEmHoras: step.maximumDurationInHours,
		idStep: step.idStep,
		initialStep: step.initialStep,
		nome: step.name,
		saidas: step.actions.map(mapActionToBack),
		sendInvite: step.sendInvite,
		sendEmail: step.sendEmail,
		retentionStepsId: step.retentionStepsId,
		isRetentionStep: step.retentionStep,
		agrupador: step.agrupador,
		registeredIdStep: step.registeredIdStep,
		isNewStep: step.IsNewStep,
		updatedStepFields: step.updatedStepFields || false,
		stepFields: step.stepFields,
		environmentUniqueKey: step.environmentUniqueKey
	};
	return mappedStep;
}

function mapActorToBack(actor) {
	let mappedActor = {
		name: actor.nome,
		id: actor.id
	};
	return mappedActor;
}

function mapActionToBack(action) {
	const mappedStepActionNotifications = action.stepActionNotifications.map((stepActionNotification) =>
		stepActionNotification.label ? stepActionNotification.id : stepActionNotification
	);
	let mappedAction = {
		listaEtapaSaida: action.destinations,
		nomeAcao: action.name,
		standartAction: action.standartAction,
		sendEmail: action.sendEmail,
		tipo: action.type,
		buttonColor: action.buttonColor,
		idStepAction: action.idStepAction,
		stepActors: mappedStepActionNotifications
	};
	return mappedAction;
}

let defaultWorkflow = {
	erased: false,
	isSupplier: true,
	isCustomer: false,
	idWorkflow: 0,
	nome: "NOVO WORKFLOW",
	etapas: [
		{
			name: "SOLICITACAO",
			fromwhere: "",
			macroStep: "",
			actor: "",
			technicalName: "",
			actions: []
		}
	]
};
